import ReactGA from 'react-ga4';

export const initGA = () => {
  // Check if user has accepted cookies
  const cookieConsent = document.cookie.includes('nearshore-africa-cookie-consent=true');
  
  if (cookieConsent) {
    ReactGA.initialize('G-33B9BJ9KPE');
  }
};

export const logPageView = () => {
  const cookieConsent = document.cookie.includes('nearshore-africa-cookie-consent=true');
  
  if (cookieConsent) {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }
};

export const logEvent = (category: string, action: string, label?: string) => {
  const cookieConsent = document.cookie.includes('nearshore-africa-cookie-consent=true');
  
  if (cookieConsent) {
    ReactGA.event({
      category,
      action,
      ...(label !== undefined ? { label } : {}),
    });
  }
};
